import { Alert, Box, Loader, Title } from '@mantine/core';
import { AppForm } from '../components/AppForm';
import { useApp } from '../hooks/useApp';
import { useParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export const EditApp = () => {
  const { shortCode } = useParams();
  const auth = useAuth();

  const { app, error } = useApp(auth?.token, shortCode);

  return error ? (
    <Alert color="red">{error}</Alert>
  ) : app ? (
    <Box>
      <Title order={3} mb={12}>
        Edit application {app.shortCode}
      </Title>
      <AppForm app={app} />
    </Box>
  ) : (
    <Loader />
  );
};
